<template>
  <div class="user">
    <div class="user__row">
      <div class="user__level">
        <img :src="Level" alt="Pic" class="user__level-img" />
        <div class="user__level-path">
          <p>مرحله {{ prizeThreshold }}</p>
        </div>
      </div>

      <div class="user__envelope">
        <img :src="Envelope" alt="Pic" class="user__envelope-img" />
        <div class="user__envelope-path">
          <p class="user__invitees">دوستان دعوت شده:</p>
          <div v-if="invitees" class="user__col user__wth">
            <div
              v-for="(item, index) in invitees.slice(0, 3)"
              :key="index"
              class="user__col user__wth"
            >
              <div class="user__inline user__space-between">
                <p class="font16">0{{ index + 1 }}</p>
                <p class="user__ltr font16">{{ item.user.mobileNumber }}</p>
              </div>
            </div>
          </div>
          <div v-if="invitees.length === 0" class="user__invitees">-</div>
        </div>
      </div>
    </div>

    <div class="user__heart">
      <img :src="Heart2" alt="Pic" class="user__heart-img" />
      <div class="user__heart-path">
        <p class="user__heart-title">مجموع جایزه‌ها</p>
        <div class="user__row">
          <div
            v-for="(item, index) in levels"
            :key="index"
            class="user__level-item"
          >
            <p class="user__level-item-title">{{ item.level }}</p>
            <p
              class="user__reward"
              :class="!discountCode[index] && 'user__gray-style'"
            >
              {{ discountCode[index] ? discountCode[index].title : item.code }}
            </p>
            <CopyButton
              :count="
                discountCode[index] ? discountCode[index].code : item.code
              "
              class="user__btn"
              :class="!discountCode[index] && 'user__disable-btn'"
              :disabled="!discountCode[index]"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- MOBILE & TABLET STYLE -->

    <div class="user__heart-slider">
      <div
        v-for="(item, index) in levels"
        :key="index"
        class="user__heart-slide"
      >
        <img :src="item.src" alt="Pic" class="user__envelope-img" />
        <div class="user__heart-slide-path">
          <p class="user__heart-slider-title">مجموع جایزه‌ها</p>
          <div class="user__inline">
            <p class="user__heart-slider-subtitle">
              {{ item.level }}
            </p>
            <p
              class="user__heart-slider-subtitle"
              :class="!discountCode[index] && 'user__gray-style'"
            >
              {{ discountCode[index] ? discountCode[index].title : item.code }}
            </p>
          </div>
          <CopyButton
            :count="discountCode[index] ? discountCode[index].code : item.code"
            class="user__heart-slider-btn"
            :class="!discountCode[index] && 'user__disable-btn'"
            :disabled="!discountCode[index]"
          />
        </div>
      </div>
    </div>
    <div class="user__buttons-row">
      <ButtonBar
        :button-icon="Close"
        class="user__close-btn close-user-info-click"
        @click="emit('closeInfo')"
      />
      <ButtonBar
        title="خروج"
        class="user__close-btn logout-click"
        @click="logout"
      />
    </div>
  </div>
</template>

<script setup>
import Heart1 from '~/assets/images/heart1.svg'
import Heart2 from '~/assets/images/heart2.svg'
import Heart3 from '~/assets/images/heart3.svg'
import Envelope from '~/assets/images/envelope.svg'
import Level from '~/assets/images/level.svg'
import Close from '~/assets/images/close.png'

const emit = defineEmits(['closeInfo'])

const props = defineProps({
  prizeThreshold: { type: String, default: '' },
})

const api = useApi()
const user = useUserStore()

// const allRewards = await api.getDiscountCode()

const invitees = computed(() => user.invitees)

const discountCode = computed(() => user.discountCodes)

const levels = [
  { level: 'مرحله اول', code: '-', src: Heart1 },
  { level: 'مرحله دوم', code: '-', src: Heart2 },
  { level: 'مرحله سوم', code: '-', src: Heart3 },
]

// const staticDiscountCodes = allRewards.map((item, index) => ({
//   ...item,
//   levelInfo: levels[index],
// }))

const auth = useAuthStore()

const logout = () => {
  localStorage.clear()
  window.location.reload()
}
</script>

<style lang="scss" scoped>
.user {
  width: 90%;
  margin: 0 auto;
  width: 100%;
  position: absolute;
  right: 0;
  left: 0;
  top: 0;
  padding-top: 45px;
  background:
    url('~/assets/images/taline-bg.svg') center / cover no-repeat,
    linear-gradient(360deg, #653684 39.31%, #653684 100%);
  z-index: 100000;
  height: 100dvh;
  overflow-y: scroll;
  @media screen and (max-width: 924px) {
    width: 100%;
  }

  &__row {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 20px;
    @media screen and (max-width: 924px) {
      flex-direction: column;
    }
  }

  &__wth {
    width: 100%;
  }

  &__inline {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 20px;
    font-size: 22px;

    color: $talineContentPrimary;
    @media screen and (max-width: 924px) {
      font-size: 16px;
    }
  }
  &__space-between {
    width: 60%;
    justify-content: space-between;
  }

  &__ltr {
    direction: ltr;
  }

  &__level,
  &__envelope,
  &__heart-slide {
    // width: min(90vw, 400px);
    // aspect-ratio: 390/275;
    position: relative;
  }

  &__envelope {
    @media screen and (max-width: 924px) {
      margin: 20px 0;
    }
  }

  &__heart-slide {
    margin-top: 30px;
  }

  &__heart {
    width: min(90vw, 842px);
    aspect-ratio: 842/297;
    position: relative;
    margin: 20px auto 100px auto;
    @media screen and (max-width: 924px) {
      display: none;
    }
  }

  &__level-img,
  &__envelope-img,
  &__heart-img {
    position: absolute;
    right: 0;
    left: 0;
    margin: 0 auto;
    top: -30px;
    z-index: 10;
  }

  &__level-img {
    width: 80px;
    @media screen and (max-width: 924px) {
      width: 53px;
    }
  }

  &__envelope-img,
  &__heart-img {
    width: 130px;
    @media screen and (max-width: 924px) {
      width: 90px;
    }
  }

  &__level-path,
  &__envelope-path {
    background: #fff;
    width: min(90vw, 400px);
    aspect-ratio: 390/275;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }

  &__level-path {
    clip-path: path(
      'M1.39973 109.387C-0.919605 61.1227 -2.07927 36.9905 12.323 21.559C26.7252 6.12755 50.88 5.62141 99.1895 4.60911L298.16 0.439821C346.735 -0.578022 371.022 -1.08694 386.076 13.8349C401.13 28.7567 400.836 53.0474 400.248 101.629L399.474 165.552C398.835 218.32 398.515 244.703 381.436 259.424C364.356 274.146 338.214 270.57 285.929 263.418L89.3116 236.525C49.9314 231.138 30.2413 228.445 18.0409 215.122C5.84058 201.799 4.88666 181.948 2.97883 142.247L1.39973 109.387Z'
    );
    @media screen and (max-width: 924px) {
      width: min(90vw, 270px);
      aspect-ratio: 270/115;
      clip-path: path(
        'M0.10187 50.115C-0.075834 38.8649 -0.164686 33.2399 1.10389 28.6226C4.11878 17.6492 12.4978 8.95646 23.3531 5.54046C27.9206 4.10312 33.5451 3.98526 44.7941 3.74955L212.919 0.226601C234.318 -0.221799 245.018 -0.445999 252.969 4.00253C258.353 7.01475 262.8 11.4551 265.821 16.834C270.283 24.7778 270.077 35.4776 269.664 56.8773C269.236 79.0129 269.023 90.0807 264.043 97.9754C260.674 103.317 255.864 107.597 250.168 110.323C241.749 114.352 230.731 113.279 208.695 111.133L41.3253 94.8333C31.169 93.8442 26.0908 93.3497 21.9238 91.7742C12.0395 88.0371 4.49769 79.8559 1.57555 69.7009C0.34362 65.4197 0.263036 60.3181 0.10187 50.115Z'
      );
    }

    p {
      color: $talineContentSecondary;
      font-weight: 900;
      font-size: 60px;
      // font-family: Croissant;

      @media screen and (max-width: 924px) {
        font-size: 40px;
      }
    }
  }

  &__envelope-path {
    clip-path: path(
      'M11.3906 91.1281C15.6085 46.9282 17.7175 24.8282 32.5367 11.755C47.3558 -1.31814 69.5463 -0.654622 113.927 0.672412L306.87 6.44159C353.34 7.83111 376.575 8.52587 390.736 23.3335C404.898 38.1412 404.555 61.3843 403.87 107.871L403.206 152.882C402.595 194.348 402.29 215.081 389.805 229.011C377.321 242.941 356.745 245.507 315.593 250.639L116.094 275.52C58.9601 282.645 30.3932 286.208 13.1797 269.486C-4.03389 252.763 -1.29911 224.105 4.17045 166.789L11.3906 91.1281Z'
    );
    padding-top: 20px;

    @media screen and (max-width: 924px) {
      width: min(90vw, 280px);
      aspect-ratio: 272/186;
      clip-path: path(
        'M7.06656 59.7611C10.4068 30.7299 12.0769 16.2143 21.9493 7.67408C31.8217 -0.866191 46.4265 -0.429492 75.6361 0.443906L206.302 4.35095C237.365 5.27978 252.897 5.74419 262.381 15.6352C271.865 25.5262 271.677 41.0637 271.301 72.1386L270.724 119.697C270.303 154.509 270.092 171.915 258.862 181.764C247.631 191.612 230.347 189.548 195.778 185.419L61.6099 169.396C30.3691 165.666 14.7487 163.8 6.17142 152.945C-2.40582 142.089 -0.607681 126.461 2.9886 95.2041L7.06656 59.7611Z'
      );
    }
  }

  &__heart-path {
    width: min(90vw, 842px);
    aspect-ratio: 842/297;
    clip-path: path(
      'M2.93266 108.155C-1.12839 57.015 -3.15892 31.445 11.9347 15.3255C27.0284 -0.79389 52.6765 -0.446594 103.973 0.247997L742.887 8.8994C790.612 9.54563 814.474 9.86874 828.956 24.9518C843.438 40.0348 842.791 63.8906 841.497 111.602L839.962 168.163C838.771 212.059 838.176 234.008 824.485 248.017C810.793 262.026 788.865 263.126 745.007 265.325L115.312 296.898C69.4708 299.197 46.5501 300.346 31.3093 286.959C16.0686 273.573 14.2518 250.695 10.6184 204.94L2.93266 108.155Z'
    );
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    background-color: #fff;
  }

  &__heart-slide-path {
    background: #fff;
    width: min(90vw, 280px);
    aspect-ratio: 280/190;
    clip-path: path(
      'M9.58098 59.8414C12.882 30.7879 14.5325 16.2612 24.4003 7.70606C34.2681 -0.849113 48.8821 -0.423366 78.11 0.428127L215.439 4.42893C246.545 5.33512 262.097 5.78822 271.592 15.6891C281.086 25.59 280.887 41.1481 280.489 72.2642L279.881 119.77C279.491 150.238 279.296 165.473 269.819 175.079C260.343 184.686 245.113 185.089 214.653 185.895L71.6493 189.68C35.7903 190.629 17.8607 191.103 7.54255 179.85C-2.77562 168.596 -0.750798 150.775 3.29885 115.132L9.58098 59.8414Z'
    );

    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }

  &__heart-title {
    color: $talineContentSecondary;
    font-weight: 900;
    font-size: 24px;
    margin-bottom: 10px;
    margin-top: 20px;
    // font-family: Croissant;
  }

  &__heart-slider-title {
    color: $talineContentSecondary;
    font-weight: 900;
    font-size: 16px;
    // font-family: Croissant;
  }

  &__heart-slider-subtitle {
    color: $talineContentPrimary;
    font-size: 16px;
    font-weight: 600;
    margin: 10px 0;
  }

  &__invitees {
    color: $talineContentSecondary;
    font-weight: 900;
    margin-bottom: 10px;
    // font-family: Croissant;
    @media screen and (max-width: 924px) {
      font-size: 16px;
    }
  }

  &__col {
    display: grid;
    place-items: center;
    gap: 5px;
    color: $talineContentPrimary;
    font-weight: 600;
  }

  &__level-item-title {
    font-size: 15px;
    font-weight: 600;
    color: $talineContentPrimary;
  }

  &__reward {
    font-size: 25px;
    font-weight: 600;
    color: $talineContentPrimary;
  }

  &__btn {
    width: 100% !important;
  }

  &__heart-slider {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    overflow-x: scroll;
    // padding-bottom: 100px;
    margin-bottom: 30px;
    @media screen and (min-width: 924px) {
      display: none;
    }
  }

  &__heart-slider-btn {
    width: 90%;
    font-size: 16px;
    @media screen and (max-width: 924px) {
      height: 46px;
      font-size: 22px;
      border-radius: 13px;
    }
  }

  &__close-btn {
    width: 25%;
    margin: 0 auto;
    margin-bottom: 150px;
  }
  &__disable-btn {
    opacity: 0.6;
    filter: grayscale(1);
  }

  &__gray-style {
    opacity: 0.6;
    filter: grayscale(1);
  }

  &__buttons-row {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
